module.exports = __webpack_public_path__ + "img/icon_memos.5696c8d1.svg";